import React from 'react'
import { AccountDetails } from '../../../types'
import { StandardDl } from './StandardDl'
import { amountFormatter } from '../../../utils/formatter'

export const BalanceInterestAccruedDl: React.FC<{ account: AccountDetails }> =
  ({ account }) => {
    return typeof account.balanceWithInterestAccruedPvtEncrypt === 'number' ? (
      <StandardDl
        title="Balance + Interest Accrued:"
        definition={amountFormatter.format(
          account.balanceWithInterestAccruedPvtEncrypt,
        )}
      />
    ) : null
  }
